import { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const RepSelectFields = ({ isr, osr, onChange }) => {
  const [isrList, setIsrList] = useState([]);
  const [osrList, setOsrList] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`${API}/settings/reps`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        setIsrList(res.data.isr_list || []);
        setOsrList(res.data.osr_list || []);
      })
      .catch(() => {});
  }, []);

  const isrItems = isrList.map((r) => (
    <option key={r} value={r}>{r}</option>
  ));

  const osrItems = osrList.map((r) => (
    <option key={r} value={r}>{r}</option>
  ));

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium mb-2">Inside Sales Rep (ISR)</label>
        <select
          data-testid="project-isr-select"
          value={isr}
          onChange={(e) => onChange("isr", e.target.value)}
          className="w-full px-4 py-2.5 bg-background border border-border rounded-lg focus:outline-none focus:ring-1 focus:ring-ring"
        >
          <option value="">Select ISR...</option>
          {isrItems}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium mb-2">Outside Sales Rep (OSR)</label>
        <select
          data-testid="project-osr-select"
          value={osr}
          onChange={(e) => onChange("osr", e.target.value)}
          className="w-full px-4 py-2.5 bg-background border border-border rounded-lg focus:outline-none focus:ring-1 focus:ring-ring"
        >
          <option value="">Select OSR...</option>
          {osrItems}
        </select>
      </div>
    </div>
  );
};
